import { IYaraMatch, IYaraRulesetStringMatches } from "../../@types";
import { MenuItem, MenuItems } from "../../../../components/@types";
import { PreviewTypes } from "../PreviewSample";

export const getCodeMirrorMode = (
  previewType: string,
  fileSubtype: string,
  typeDisplay?: string
) => {
  if (previewType !== PreviewTypes.TEXT) {
    return "simple";
  }
  if (fileSubtype === "javascript") {
    return "javascript";
  }
  if (fileSubtype === "html" || fileSubtype === "htm") {
    return "htmlmixed";
  }
  if (
    ["vb", "visualbasic", "visual basic", "vba", "vbscript"].includes(
      fileSubtype
    )
  ) {
    return "vbscript";
  }
  if (typeDisplay?.startsWith("xml:")) {
    return "xml";
  }
  return "simple";
};

export const getFilterOptions = (
  stringMatches?: IYaraRulesetStringMatches[],
  selectedRulesetName?: string,
  selectedRuleName?: string
): {
  rulesetOptions: MenuItems;
  ruleOptions: MenuItems;
  variableOptions: MenuItems;
} => {
  if (stringMatches == null) {
    return {
      rulesetOptions: [],
      ruleOptions: [],
      variableOptions: []
    };
  }

  const rulesetOptions = stringMatches.map(ruleset => ({
    label: ruleset.ruleset_name,
    value: ruleset.ruleset_name
  }));

  const rules = stringMatches.find(
    ruleset => ruleset.ruleset_name === selectedRulesetName
  )?.rules;

  const ruleOptions =
    rules?.map(rule => ({
      label: rule.rule_name,
      value: rule.rule_name
    })) ?? [];

  const variableOptions =
    rules
      ?.find(rule => rule.rule_name === selectedRuleName)
      ?.strings.map(string => ({
        label: string.string,
        value: string.string
      })) ?? [];

  return {
    rulesetOptions,
    ruleOptions,
    variableOptions
  };
};

export type MatchHighlight = { line: number; start: number; end: number };

export const calculateTextMarks = (
  matches?: IYaraMatch[],
  offset = 10,
  charactersPerByte = 2,
  charactersPerGroup = 4,
  bytesPerLine = 16
) => {
  const result: MatchHighlight[] = [];
  matches?.forEach(match => {
    const startLine = Math.floor(match.offset / bytesPerLine);
    const endLine = Math.floor(
      (match.offset + match.length - 1) / bytesPerLine
    );

    const startChar =
      (match.offset % bytesPerLine) * charactersPerByte +
      Math.floor(
        ((match.offset % bytesPerLine) * charactersPerByte) / charactersPerGroup
      ) +
      offset;
    const endChar =
      ((match.offset + match.length) % bytesPerLine) * charactersPerByte +
      Math.floor(
        (((match.offset + match.length) % bytesPerLine) * charactersPerByte) /
          charactersPerGroup
      ) +
      offset;

    if (startLine === endLine) {
      result.push({ line: startLine, start: startChar, end: endChar });
    } else {
      const lastPossibleCharacterInLine =
        offset +
        bytesPerLine * charactersPerByte +
        Math.floor((bytesPerLine * charactersPerByte) / charactersPerGroup) -
        1;

      result.push({
        line: startLine,
        start: startChar,
        end: lastPossibleCharacterInLine
      });
      for (let line = startLine + 1; line < endLine; line++) {
        result.push({ line, start: offset, end: lastPossibleCharacterInLine });
      }
      result.push({ line: endLine, start: offset, end: endChar });
    }
  });

  return result;
};

export const getMenuItemFromString = (value?: string): MenuItem | undefined => {
  if (value != null) {
    return {
      value,
      label: value
    };
  } else {
    return undefined;
  }
};
